import React, { useEffect, useState } from 'react';
import 'moment/locale/pt';

import CustomizedTables from '../../../../components/Table';

import {
  Button
} from 'reactstrap';
import { enqueueSnackbar } from 'notistack';
import { GetFetch, PutFetch } from '../../../../services/apiBase';
import LoadingComponent from '../../../../components/LoadingComponent';
import PaginationRounded from '../../../../components/NewPagination';

export default function CprAccrualByDay({ cprId, type }) {
  const [loading, setLoading] = useState(true)
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [limit] = useState(25);
  const [cprAccrualByDay, setCprAccrualByDay] = useState(undefined)

  const COLUMNSTABLE = [
    {
      headerName: 'Dia',
      type: 'default',
      value: {
        first: {
          value: 'day_accrual'
        }
      },
      field: 'day_accrual'
    },
    {
      headerName: 'Rendimento diário',
      type: 'money',
      value: {
        first: {
          value: 'daily_accrual'
        }
      },
      field: 'daily_accrual'
    },
    {
      headerName: 'Rendimento acumulado',
      type: 'money',
      value: {
        first: {
          value: 'accumulated_accrual'
        }
      },
      field: 'accumulated_accrual'
    },
    {
      headerName: 'Data',
      type: 'date',
      value: {
        first: {
          value: 'accrual_date'
        }
      },
      field: 'accrual_date'
    }
  ]

  const updateDailyAccrual = async () => {
    setLoading(true)
    try {
      const { data } = await PutFetch('/financial/cprAccrual/update', {
        params: {
          cpr_id: cprId
        }
      })

      await getCprAccrualByDay()

      enqueueSnackbar('Atualização realizada com sucesso!', { variant: 'success' });

      setLoading(false)

    } catch (error) {
      console.log(error);
      setLoading(false)
      enqueueSnackbar('Erro ao atualizar os rendimentos diários', { variant: 'error' });
    }
  }

  const getCprAccrualByDay = async () => {
    setLoading(true)
    try {
      const { data } = await GetFetch('/financial/cprAccrual/get', {
        params: {
          limit: limit,
          page: currentPage,
          cpr_id: cprId
        }
      })

      console.log(data, data.lastPage)
      setCprAccrualByDay(data.data);
      setTotalPages(data.lastPage)
      setLoading(false)

    } catch (error) {
      console.log(error);
      enqueueSnackbar('Erro ao carregar os rendimentos diários', { variant: 'error' });
      
    }
  }

  useEffect(() => {
    getCprAccrualByDay()
  }, [currentPage])

  return (
    <div>
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}>
        <h4 style={{ marginTop: 10, marginLeft: 10 }}>Rendimento diário</h4>
        {
          (type === 'ipca_bullet' || type === 'ipca_cupom') &&
        <Button
          color="warning"
          style={{
            height: 36
          }}
          onClick={() => updateDailyAccrual()}
        >
          Atualizar
        </Button>
        }
      </div>
      <div>
        <ul>
          {
            loading ?
              <div>
                <LoadingComponent />
              </div> :
              <CustomizedTables 
                data={cprAccrualByDay}
                columns={COLUMNSTABLE}
              />
          }

          <PaginationRounded count={totalPages} page={currentPage} handleChange={setCurrentPage} />
        </ul>
      </div>
    </div>
  )
}